"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deptStaff = require("@/api/auth/deptStaff");
var _SwPage = _interopRequireDefault(require("@/views/common/SwPage.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'deptStaffIndex',
  components: {
    SwPage: _SwPage.default
  },
  data: function data() {
    return {
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'deptName'
      },
      deptStaffTree: [],
      deptStaffTreeLoading: false,
      listQuery: {
        page: 1,
        limit: 10,
        deptId: null,
        keywords: null
      },
      userList: [],
      loading: false,
      total: 0
    };
  },
  created: function created() {
    this.getDeptStaffTree();
    this.getDeptStaffUserPage();
  },
  methods: {
    handleNodeClick: function handleNodeClick(data, node) {
      if (node.expanded) {
        this.listQuery.deptId = data.id;
      } else {
        this.listQuery.deptId = null;
      }
    },
    getDeptStaffTree: function getDeptStaffTree() {
      var _this = this;
      this.deptStaffTreeLoading = true;
      (0, _deptStaff.getDeptStaffTree)().then(function (res) {
        var data = res.data;
        if (data) {
          _this.deptStaffTree = data.records;
        }
        setTimeout(function () {
          _this.deptStaffTreeLoading = false;
        }, 500);
      });
    },
    getDeptStaffUserPage: function getDeptStaffUserPage() {
      var _this2 = this;
      this.loading = true;
      (0, _deptStaff.queryStaffUserPage)(this.listQuery).then(function (res) {
        _this2.total = res.total;
        _this2.userList = res.records;
        //延迟关闭
        setTimeout(function () {
          _this2.loading = false;
        }, 500);
      });
    },
    syncDepartment: function syncDepartment() {
      var _this3 = this;
      (0, _deptStaff.syncDepartment)().then(function (res) {
        _this3.getDeptStaffTree();
      });
    },
    syncDepartmentUser: function syncDepartmentUser() {
      var _this4 = this;
      (0, _deptStaff.syncDepartmentUser)().then(function (res) {
        _this4.getDeptStaffTree();
      });
    }
  }
};